// DO NOT EDIT -- generated from fs/shared/flags/flags.proto

export enum Flag {
  /** Permissions flags. */
  PermViewPlayback = 0,
  PermViewSessionsForUser = 1,
  PermViewUserMetaData = 2,
  PermViewListOfUsers = 3,
  PermSearch = 4,
  PermModifySegments = 5,
  /** Allows viewing credit card info. */
  PermViewBilling = 13,
  /** Allows modifying both card info and the current subscription */
  PermModifyBilling = 14,
  PermModifyOwnSettings = 17,
  PermTakeNotes = 19,
  PermExportData = 20,
  PermViewPageInsights = 22,
  PermDeleteNotes = 23,
  PermViewOwnSettings = 26,
  PermViewUserData = 100,
  PermModifyUserData = 101,
  PermDeleteUserData = 27,
  PermModifyUmbrella = 28,
  PermViewOrgMetadata = 31,
  PermModifyOrgMetadata = 32,
  PermConfigureIntegrations = 33,
  PermInstallIntegrations = 34,
  PermViewIntegrations = 117,
  PermViewTeam = 35,
  PermModifyTeam = 36,
  /** Allows viewing the subscription i.e. session limit, current usage, without viewing credit card info. */
  PermViewSubscription = 37,
  PermViewAllApiKeys = 40,
  PermModifyAllApiKeys = 41,
  PermViewUmbrella = 42,
  PermViewHooks = 43,
  PermModifyHooks = 44,
  PermAcceptTermsAndConditions = 45,
  PermViewAjaxSettings = 46,
  PermViewSearchMetadata = 47,
  PermViewOwnApiKeys = 48,
  PermModifyOwnApiKeys = 49,
  PermModifyFunnels = 50,
  PermModifyAnalyses = 51,
  PermViewMetrics = 52,
  PermModifyMetrics = 53,
  PermViewFunnelMetrics = 59,
  PermModifyRevenueInsights = 60,
  PermModifyNamedElements = 61,
  PermViewContacts = 79,
  PermModifyContacts = 62,
  PermViewElementAttributes = 90,
  PermModifyElementAttributes = 63,
  PermModifyDefinedEvents = 66,
  PermViewPageMetrics = 71,
  PermViewSeatLastActivity = 78,
  PermViewSessionManagement = 87,
  PermModifySessionManagement = 88,
  PermViewRetentionMetrics = 93,
  PermModifyRetentionMetrics = 94,
  PermDeleteBySegment = 95,
  PermExportCSVData = 114,
  /** Allows modifying experiment settings, such as session summary opt in/out */
  PermModifyExperimentSettings = 115,
  PermViewSettingsPages = 116,
  /** Privacy perms */
  PermViewPrivacy = 38,
  PermModifyDiscardIpAddresses = 54,
  PermModifyElementBlocks = 55,
  PermModifyAjaxAllowList = 56,
  PermViewAjaxAllowList = 65,
  PermModifyDataloss = 85,
  PermModifyPbd = 86,
  PermModifyUrlPrivacy = 99,
  /** Recording perms */
  PermViewRecordingSettings = 29,
  /** Covers all recording settings except separate permissions specified below. */
  PermModifyRecordingSettings = 30,
  PermModifyWatchedElems = 57,
  PermModifyCustomVars = 58,
  PermModifyBehaviorSignalSettings = 64,
  PermModifyElementDeferreds = 105,
  PermModifyFsImpactsAudits = 113,
  /** SSO perms */
  PermViewSsoSettings = 89,
  PermModifySsoSettings = 67,
  /** Page Perms */
  PermViewPageDefintions = 68,
  PermModifyOwnPageDefinitions = 69,
  PermModifyPageDefinitions = 70,
  /**
   * Library object perms. Shared across all library objects (metrics, funnels, segments, etc).
   * Permission to create library objects
   */
  PermCreateLibraryObjects = 72,
  /** Permission to view published objects */
  PermViewLibraryObjects = 73,
  /** Permission to modify any library object, including ones owned by other users */
  PermModifyLibraryObjects = 74,
  /** Permission to delete any library object, including ones owned by other users */
  PermDeleteLibraryObjects = 75,
  /** Permission to modify objects owned by the user */
  PermModifyOwnLibraryObjects = 76,
  /** Permission to delete objects owned by the user */
  PermDeleteOwnLibraryObjects = 77,
  /**
   * Embed Perms for shared customers
   * Allows minting of a new signed session, i.e. requesting an signed session (access token) with API key
   */
  PermMintOwnSession = 91,
  /** Embed Perms for OEM */
  PermMintSessionForOrgSeat = 80,
  PermViewEmbedPartner = 81,
  PermModifyEmbedPartner = 82,
  PermViewEmbedOrg = 83,
  PermModifyEmbedOrg = 84,
  /** Notifications related permissions */
  PermViewNotifications = 102,
  PermModifyOwnNotifications = 103,
  PermDeleteNotificationBotRecipients = 104,
  /** Space related permissions */
  PermViewSpace = 106,
  /** Can perform all CRUD operations on a Space, as well as move objects not owned by that user to a Space. */
  PermModifySpace = 107,
  /** Can manage the Space card view, create references to objects in a Space, and move objects owned by the user. */
  PermModifySpaceObjects = 108,
  /** Spec related permissions */
  PermViewSpec = 109,
  PermModifySpec = 110,
  PermViewSpecMapping = 111,
  PermModifySpecMapping = 112,
  PermViewSCIMSettings = 118,
  PermModifySCIMSettings = 119,
  /** Can send requests to the SCIM API to perform CRUD operations on Fullstory Users and Groups */
  PermAccessSCIMAPI = 120,
  /** Classification rules related permissions */
  PermViewClassificationRules = 121,
  PermModifyClassificationRules = 122,
  /** Feature flags. */
  FeatDataExport = 16408,
  FeatDevtools = 16425,
  FeatUnlimitedSessions = 16428,
  FeatNativeMobile = 16431,
  /** Whether this org uses FS.Keep rules to decide which sessions to process */
  FeatFsKeep = 16437,
  FeatArchitectRole = 16442,
  FeatWatchedElems = 16444,
  FeatSelfServiceSSO = 16445,
  /** Renamed from ExpImpacts */
  FeatImpacts = 32867,
  /** Renamed from ExpAlerts */
  FeatAlerts = 32835,
  FeatDataLayerObserver = 16447,
  FeatJourneys = 16448,
  FeatWarehousing = 16449,
  FeatSessionOverages = 16450,
  FeatSessionPage = 16451,
  FeatRetention = 16452,
  FeatMetricInsights = 16453,
  /** Deprecated, will be deleted in a future PR */
  FeatDQM = 16454,
  FeatSpaces = 16455,
  FeatDashboards = 16456,
  FeatWebhooks = 16457,
  FeatGoLive = 16458,
  FeatConfigurableFormPrivacy = 16459,
  FeatClientSideRagehooks = 16460,
  FeatConversionMaps = 16461,
  /** this is a wayfinder org */
  FeatWayfinder = 16462,
  FeatUnlimitedSeats = 16463,
  FeatFSTA = 16464,
  FeatExplorerRole = 16465,
  FeatSplitProcessing = 16466,
  FeatVisitApi = 16467,
  FeatSuggestedElements = 16468,
  FeatSCIMProvisioning = 16469,
  FeatAttributeSuggestions = 16470,
  FeatSessionSummaries = 16471,
  FeatOpportunities = 16472,
  /** searchie flags. */
  SearchieTopErrorClicks = 49152,
  SearchieTopRageClicks = 49153,
  SearchieTopDeadClicks = 49154,
  SearchieTrafficByRefererHost = 49155,
  SearchieTrafficByUtmSource = 49156,
  SearchieTrafficByUtmCampaign = 49157,
  SearchieTrafficByUtmMedium = 49158,
  SearchieTrafficByBrowser = 49159,
  SearchieDeviceBreakdown = 49160,
  SearchieEventFunnel = 49162,
  SearchieMostActiveUsers = 49163,
  SearchieSegmentHealth = 49164,
  SearchieTopPages = 49165,
  SearchieRageGrade = 49166,
  SearchieActivitySummary = 49167,
  SearchieDailyActives = 49168,
  /** Matching Users. Default sorted by recency (but we might allow alternate sorts in the future). */
  SearchieMatchingUsers = 49169,
  /** Computes total counts of Indv/Sessions/Events for TimeRanges. These counts can be shared across all segments. */
  SearchieTimeRangeCounts = 49170,
  /** Client-only feedback searchie. */
  SearchieFeedback = 49171,
  SearchieScreenResolutions = 49173,
  SearchieSlowPages = 49175,
  SearchieMobileDevices = 49177,
  SearchieMobileAppVersions = 49178,
  SearchieMobileResolutions = 49179,
  SearchieMobileOsVersions = 49180,
  SearchieApiErrors = 49181,
  SearchieMostCommonEntryPages = 49182,
  /** NEXT ID (searchies) = 49184 */
  SearchieUserTrendsCard = 49183
}

/**
 * FlagsProto is a protobuf representation of Flags. Convert
 * Flags to this proto in order to represent flag sets in RPC
 * requests and responses.
 */
export interface FlagsProto {
  /** Flag values, keyed by the int32 value of the Flag enum. */
  flags: { [key: string]: number };
}
